import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { Subscription } from 'rxjs';
import { AngularGridInstance, FieldType, GridOption } from 'angular-slickgrid';
import { RestApiService } from '../rest-api.service';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../message.service';
import { ConfigService } from '../config.service';

@Component({
    selector: 'app-ticket-search',
    templateUrl: './ticket-search.component.html',
    styleUrls: ['./ticket-search.component.css']
})
export class TicketSearchComponent implements OnInit, OnDestroy {

    private respObject: any;
    private notifier: NotifierService;
    typeChecked: any;
    columnDefinitions = [];
    clientId: number;
    userGroups = [];
    public grpLevel: number;
    userGroupId: number;
    groupName: string;
    userGroupSelected: number;
    private userAuth: Subscription;
    private ticket_no: string;
    gridOptions: GridOption;
    angularGrid: AngularGridInstance;
    gridObj: any;
    dataset: any[];
    seq: number;
    displayCit: boolean;
    displayCr: boolean;
    displayPr: boolean;
    isViewTicket: boolean;
    private masterCloseSubscribe: Subscription;
    inciId: number;

    ticketclientId: number;
    ticketTypeId: number;
    viewSeq: number;
    type: string;
    displayDraft: boolean;

    displayACC: boolean;
    displyType: string;
    constructor(private _rest: RestApiService, private actRoute: ActivatedRoute, private messageService: MessageService,
        notifier: NotifierService, private config: ConfigService) {
        this.notifier = notifier;
        this.masterCloseSubscribe = this.messageService.masterCloseModalSubject.subscribe((data) => {
            this.messageService.clearSession();
            window.location.href = this.config.API_ROOT;
        });
    }

    angularGridReady(angularGrid: AngularGridInstance) {
        // console.log('grid initiate');
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
    }

    ngOnInit(): void {
        this.isViewTicket = true;
        this.displayCit = false;
        this.displayCr = false;
        this.displayPr = false;
        this.displayDraft = false;
        this.displayACC = false;
        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            // enableCheckboxSelector: true,
            enableRowSelection: true,

        };
        this.dataset = [];
        this.actRoute.queryParams.subscribe(params => {

            this.clientId = params['clientId'];
            const encodedUserName = params['ln'];
            this.typeChecked = params['tp'];
            const gp = params['gp'];
            const token = params['token'];
            this.ticket_no = params['ticket_no'];
            this.type = params['type'];
            this.displyType = params['displyType'];
            let userName;
            if (encodedUserName) {
                userName = this.messageService.xorEncode(atob(encodedUserName), this.messageService.SECRET_TOKEN);
            }
            if (this.clientId !== undefined && token !== undefined && userName !== undefined) {

                this.messageService.clearSession();
                const data = { clientId: this.clientId, token: token, loginName: userName };

                this._rest.tokenValidation(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.messageService.addSessionData(this.respObject.details, token, this.clientId);
                        this.messageService.tokenSubject.next();
                        sessionStorage.removeItem('dd');
                        this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                            this.userGroups = auth[0].groupId;
                            this.userGroupSelected = Number(gp);
                            if (this.userGroups !== undefined) {
                                for (let i = 0; i < this.userGroups.length; i++) {
                                    if (Number(gp) === Number(this.userGroups[i].groupId)) {
                                        this.grpLevel = this.userGroups[i].level;
                                        break;
                                    }
                                }
                                this.onPageLoad();
                            }

                        });
                    } else {
                        this.messageService.clearSession();
                        this.notifier.notify('error', this.messageService.URL_TOKEN_ERROR1);

                    }
                }, (err) => {
                    this.messageService.clearSession();
                    this.notifier.notify('error', this.messageService.TOKEN_TIMEOUT_ERROR);

                });
            } else {
                this.notifier.notify('error', 'client id not defined....');

            }
        });
    }

    onPageLoad() {
        this.getTicketDetails();
    }

    getTicketDetails() {
        this._rest.getAnyTicketById({ clientId: this.clientId, ticketId: this.ticket_no }).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {

                const data = this.respObject.details;

                this.typeChecked = data[0].ticketTypeId;
                this.seq = data[0].ticket_seq;
                this.viewSeq = data[0].view_seq;
                this.dataset = data[0];

                data[0].requestedDate = this.messageService.datePipeFunc(data[0].requestedDate);
                this.ticketclientId = data[0].clientid;
                this.ticketTypeId = data[0].ticketTypeId;
                //getSolutionsTicketWise

                this.userGroupSelected = data[0].gid;
                for (let i = 0; i < this.userGroups.length; i++) {
                    if (Number(this.userGroupSelected) === Number(this.userGroups[i].groupId)) {
                        this.grpLevel = this.userGroups[i].level;
                        break;
                    }
                }

                this.setDisplayModal();
                setTimeout(() => {
                    this.messageService.setModalData(this.dataset);
                }, 100);

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
        });
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

    setDisplayModal() {
        if (this.seq === 5) {
            this.displayCr = true;
            this.displayPr = false;
            this.displayCit = false;
            this.displayDraft = false;
            this.displayACC = false;
        } else if (this.seq === 6) {
            this.displayPr = true;
            this.displayCr = false;
            this.displayCit = false;
            this.displayDraft = false;
            this.displayACC = false;
        } else {
            this.displayCit = true;
            this.displayPr = false;
            this.displayCr = false;
        }

    }

}
